// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#Honorific[data-v-af9cb956]  .vs__dropdown-toggle{height:37.99px!important}", ""]);
// Exports
module.exports = exports;
